function fn_parts_checkContentHeight(){
	if ($('.js-side-panel').length){
		var sideHeight = $('.js-side-panel').outerHeight();
		var contentHeight = $('.page-content-block').outerHeight();
	    if($(window).width() > 992 && $('.page-content-block').length){
	    	if (contentHeight - 115 < sideHeight){
				  $('.page-content-block').css('height', sideHeight + 115);
	    	} 
	    }
	} 
}